import "./property-info4.css";
import React, { Suspense, useState, useEffect } from "react";
import { loadUser } from "../../actions/authActions";
import { getPropertyList, applyProperty } from "../../actions/propertyAction";

import {
  unlikeProperty,
  likeProperty,
  hiddenProperty,
  reportProperty,
} from "../../actions/propertyAction";
import {

  Fix_value_id,
  settings,

  home_appliances_id,
  restrictions_val_id,

} from "./propertyArray";
import moment from "moment";

import Modal from "@mui/material/Modal";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button
} from "@mui/material";
import Box from "@mui/material/Box";
import {
 
  CircularProgress,
} from "@mui/material"; 

import _ from "lodash";

import {
  getPropertyDetail,
  PrintPropertyDetail,
} from "../../actions/propertyAction";
import { connect, useSelector } from "react-redux";
import Slider from "react-slick";
import { Link, useHistory, useParams, Redirect } from "react-router-dom";

import {  Form, } from "reactstrap";
import $ from "jquery";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";

import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader


import ImageGallery from "react-image-gallery";

import "./swiper.css";
import "./swiper1.scss";
import {  FaFileUpload } from "react-icons/fa";
import Header from "../../DefaultLayout/Header";
import { toast } from "react-toastify";
import { addChat } from "../../actions/firebaseAction";
import MapComponentDetail from "../../components/GoogleMapDetail";
import swal from "sweetalert";
import { dropdownPropertyField } from "../../actions/propertyFieldAction.js";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";

const BrokenImage = "assets/no-picture-available-icon-1.jpg";


const PropertyInfo4 = (props) => {
  const history = useHistory();

  const {
  
    getPropertyList,
    getPropertyDetail,
    applyProperty,
    auth,
    label,
  } = props;
  const { frontLabelsName } = label;
  const isAuth = auth.isAuthenticated;

  const subscriptions = useSelector((state) => state.subscription);
  const subscription_details = subscriptions?.runningSubscription?.message;
  const lng = localStorage.getItem("prevLangFront") ;
  const { id } = useParams();


  const [detailData, setDetailData] = useState();
  const [applyModal, setApplyModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openApplyBox, setOpenApplyBox] = useState(false);
  const [applyBoxData, setApplyBoxData] = useState("");
  const[disableSubmitButton,setDisableSubmitButton]=useState(false)
  const [mapLoading, setMapLoading] = useState(false);
  const [pdfurl, setPdfUrl] = useState("");

  const[pdfError,setPdfError] = useState("");
  const properties = useSelector((state) => state.properties);
  const { property, propertyLoading } = properties;
  const [propertyInclude, setPropertyInclude] = useState([]);
  const [propertyHome, setPropertyHome] = useState([]);
  const [propertyRestriction, setPropertyRestriction] = useState([]);

  const [includedType, setIncludedType] = useState([]);
  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherType, setOtherType] = useState([]);


  useEffect(() => {
    window.scrollTo(0, 0);
    setMapLoading(true);
    // getPropertyList(
    //   1,
    //   20,
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   ""
    // );
    getPropertyDetail(id).then((res) => {
      setMapLoading(false);
      setDetailData(res);
      setPropertyInclude(res?.included);
      setPropertyHome(res?.homeAppliances);
      setPropertyRestriction(res?.restrictions);
    });
  }, [id]);

  useEffect(() => {
    props.dropdownPropertyField("").then((res) => {
      setIncludedType(res?.type_1);
      setHomeApplianceType(res?.type_2);
      setRestrictionsType(res?.type_3);
      setAccessType(res?.type4);
      setOtherType(res?.type5);
    });
  }, []);


  const handleFileChange = (e) => {
    e.preventDefault();
    let validationFlag = true;
   

 if (e.target.files.length) {
      let file = e.target.files[0];
 
      if (!file.name.match(/\.(PDF|pdf)$/)) {
        setPdfError(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_please_select_pdf")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_please_select_pdf"
                )[0]["value"] || "lbl_please_select_pdf"
              : "lbl_please_select_pdf"
            : "lbl_please_select_pdf"
        );
        validationFlag = false;
      }  else {
        validationFlag = true;
        setPdfError("");
      }

      if (validationFlag) {
     
         setPdfUrl(file)
       
      }
    }
  };

  const loginCheck = async (data) => {
  
    if (auth.isAuthenticated) {
      setPdfError("")
      setPdfUrl("")
      setApplyBoxData(data);
      setOpenApplyBox(true);
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };


  // Toggle for Modal
  const applyToggle = () => setApplyModal(true);

  const handleApplyModal = (e) => {
    e.preventDefault();
    setApplyModal(false);
    setOpenApplyBox(false);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  // please dont change code becoz we are mange.
  let right = _.differenceBy(Fix_value_id, detailData?.included);
  let righthomeapp = _.differenceBy(
    home_appliances_id,
    detailData?.homeAppliances
  );

  let rightrestrictions = _.differenceBy(
    restrictions_val_id,
    detailData?.restrictions
  );

  const imgSlider_Model = detailData?.photo_gallery.map((val) => {
    return {
      original: val,
      thumbnail: val,
    };
  });



  // like or unlike code start here

  const like = async (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newAddLike = {
        property_id: detailData?._id,
      };
      const res = await props.likeProperty(newAddLike).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
              "value"
              ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        getPropertyDetail(id).then((res) => {
          setDetailData(res);
        });
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // end here like and unlike

  // unlike funtion start here

  const unlike = async (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      const res = await props.unlikeProperty(detailData?._id).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
              ress.message
              : ress.message
            : ress.message
        );
        getPropertyDetail(id).then((res) => {
          setDetailData(res);
        });
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // end here unlike

  // hidden property start here

  const hidden = async (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newhidden = {
        property_id: detailData?._id,
      };
      const res = props.hiddenProperty(newhidden).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
              "value"
              ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        getPropertyDetail(id).then((res) => {
          setDetailData(res);
        });
        history.push("/properties");
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // print
  const HandlePrint = (e) => {
    e.preventDefault();
    props.PrintPropertyDetail(id).then((res) => {
      window.open(res, "_blank");
  
    });
  };

  // report details

  const reportdetails = async (e, property_id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      history.push(`/report-property/${property_id}`);
  
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const getTypeName = (val) => {
    if (val === "detachedHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
          "value"
          ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house";
    } else if (val === "duplex") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
          "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex";
    } else if (val === "tripleAptHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
          "value"
          ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house";
    } else if (val === "aptBulding") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
          "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building";
    } else if (val === "townhouseTwin") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
          "value"
          ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin";
    } else if (val === "garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
          "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "summerHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
          "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house";
    } else if (val === "cotenant") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
          "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant";
    } else if (val === "hotelGesthouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
          "value"
          ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house";
    }
  };

  const handleAddChat = () => {
    const data = {
      property: detailData._id,
      owner: detailData?.posted_by?._id,
      user: auth?.user?._id,
    };
    props.addChat(data).then((res) => {
      history.push({
        pathname: `/chat-view/${res.data?.result?._id}`,
        state: { data: res.data?.result?._id },
      });
    });
  };

  const applyModelProperty = async (e) => {
    e.preventDefault();
    let validationFlag=false
     if(!pdfurl){
      validationFlag=false
      setPdfError(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_renter_cv_is_required")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_renter_cv_is_required"
                )[0]["value"] || "lbl_renter_cv_is_required"
              : "lbl_renter_cv_is_required"
            : "lbl_renter_cv_is_required"
        );
    }else{
     setPdfError("") 
      validationFlag=true
    }
    if( validationFlag){

    setDisableSubmitButton(true)
     const formData = new FormData();
     formData.append("property",id)
          formData.append("renters_cv",pdfurl)

    const res = await applyProperty(formData).then((ress) => {
      setDisableSubmitButton(false)
        setPdfUrl("")
    setApplyModal(false);
    getPropertyDetail(id).then((res) => {
      setDetailData(res);
    });
    setOpenApplyBox(false);
      toast.success(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
            ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
            ress.message
            : ress.message
          : ress.message
      );
    }).catch((err)=>{
      setDisableSubmitButton(false)
    })

  }
  };

  if (isAuth == false) {
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_please_login").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login")[0]["value"] ||
          "lbl_please_login"
          : "lbl_please_login"
        : "lbl_please_login",
      text: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_login_view_properties")
          .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_login_view_properties")[0][
          "value"
          ] || "lbl_login_view_properties"
          : "lbl_login_view_properties"
        : "lbl_login_view_properties",
      icon: "info",
      buttons: [
        null,
          frontLabelsName
         ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
           ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
               "value"
             ] || "lbl_continue"
           : "lbl_continue"
         : "lbl_continue"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
    return <Redirect to={"/login"} />;
  }

  if (subscription_details !== "Your subscription is active.") {
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe")[0][
          "value"
          ] || "lbl_purchage_subscribe"
          : "lbl_purchage_subscribe"
        : "lbl_purchage_subscribe",
      text: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_to_view").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_to_view")[0][
          "value"
          ] || "lbl_subscribe_to_view"
          : "lbl_subscribe_to_view"
        : "lbl_subscribe_to_view",
      icon: "info",
      buttons: [
        null,
          frontLabelsName
         ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
           ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
               "value"
             ] || "lbl_continue"
           : "lbl_continue"
         : "lbl_continue"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
    return <Redirect to={"/subscription"} />;
  }

  const includs = (filedData, newData) => {
    let result = filedData.filter(function (obj) {
      return newData.some(function (val) {
        return val === obj._id;
      });
    });
    return result.map((d) => {
      return (
        <>
          <div className="setting-links1">
            <p>
              <a>
                <span className="d-flex cus-space1">
                  <img src="assets/tick.svg" />
                  {Array.isArray(d?.name) ? d?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:d?.name }
                </span>
              </a>
            </p>
          </div>
        </>
      );
    });
    // return result.name
  };

  const includs1 = (filedData, newData) => {

    let result = filedData.filter((elm) => !newData.includes(elm._id));
  
    return result.map((d) => {
      return (
        <>
          <div className="setting-links1">
            <p>
              <a>
                <span className="d-flex cus-space1">
                  <img src="assets/cross.svg" />
                  {Array.isArray(d?.name) ? d?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:d?.name }
                </span>
              </a>
            </p>
          </div>
        </>
      );
    });

  };

  const includs2 = (filedData) => {
    return filedData.map((d) => {
      return (
        <>
          <div className="setting-links1">
            <p>
              <a>
                <span className="d-flex cus-space1">
                  <img src="assets/cross.svg" />
                  {Array.isArray(d?.name) ? d?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:d?.name }
                </span>
              </a>
            </p>
          </div>
        </>
      );
    });
  };

  const imageNotFound = (event) => {
    event.currentTarget.src = BrokenImage;
  };

 

  const getAvailabilityMultilanguage = (value) => {
    if (value === "Before Noon") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_before_noon").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_before_noon")[0]["value"] ||
          "lbl_before_noon"
          : "lbl_before_noon"
        : "lbl_before_noon";
    } else if (value === "After Noon") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_after_noon").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_after_noon")[0]["value"] ||
          "lbl_after_noon"
          : "lbl_after_noon"
        : "lbl_after_noon";
    } else {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_all_day").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_all_day")[0]["value"] ||
          "lbl_all_day"
          : "lbl_all_day"
        : "lbl_all_day";
    }
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}

        <DashboardNavbar />
      </Suspense>

      <div className="div-wrapper">
        <div className="row">
          <div className="links-main1 d-flex col-lg-12 mb-2">
            
          </div>
        </div>
        <div className="row row_style">
          <div className="col-lg-8 col-md-12">
            <div className="links-main1 d-flex col-lg-12 col-md-12 mb-3">
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_was_listed")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_property_was_listed"
                    )[0]["value"] || "lbl_property_was_listed"
                    : "lbl_property_was_listed"
                  : "lbl_property_was_listed"}{" "}
                :{" "}
                <span>{moment(detailData?.createdAt).format("DD/MM/yyyy")}</span>
              </p>
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_last_modified")
                    .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_last_modified")[0][
                    "value"
                    ] || "lbl_last_modified"
                    : "lbl_last_modified"
                  : "lbl_last_modified"}{" "}
                :{" "}
                <span>{moment(detailData?.updatedAt).format("DD/MM/yyyy")}</span>
              </p>
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_viewed")
                    .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_property_viewed")[0][
                    "value"
                    ] || "lbl_property_viewed"
                    : "lbl_property_viewed"
                  : "lbl_property_viewed"}{" "}
                : <span>{detailData?.views}</span>
              </p>
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_no_of_photos").length >
                    0
                    ? frontLabelsName.filter((e) => e.key == "lbl_no_of_photos")[0][
                    "value"
                    ] || "lbl_no_of_photos"
                    : "lbl_no_of_photos"
                  : "lbl_no_of_photos"}{" "}
                : <span>{detailData?.photo_gallery.length}</span>
              </p>
              {detailData?.unique_No && (
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_unique_per_no")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_unique_per_no")[0][
                      "value"
                      ] || "lbl_unique_per_no"
                      : "lbl_unique_per_no"
                    : "lbl_unique_per_no"}{" "}
                  : <span>{detailData?.unique_No}</span>
                </p>
              )}
           
              {detailData?.wholeProperty=="detachedHouse" && (
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_whole_property_part")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_whole_property_part"
                      )[0]["value"] || "lbl_whole_property_part"
                      : "lbl_whole_property_part"
                    : "lbl_whole_property_part"}{" "}
                  :{" "}
                  <span>
                    {detailData?.wholeProperty === "yes"
                      ? frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_yes").length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_yes")[0][
                          "value"
                          ] || "lbl_yes"
                          : "lbl_yes"
                        : "lbl_yes"
                      : ""}
                    {detailData?.wholeProperty === "no"
                      ? frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_no").length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_no")[0][
                          "value"
                          ] || "lbl_no"
                          : "lbl_no"
                        : "lbl_no"
                      : ""}
                  </span>
                </p>
              )}
            </div>
            <div className="view-port-main1">
              <div className="view-card-main1">
                <div className="img-view-main1">
              
                  <LazyLoadImage
                    alt="cover_photo"
                    height="100%"
                    src={
                      detailData?.cover_photo
                        ? detailData?.cover_photo
                        : detailData?.photo_gallery[0]
                    } // use normal <img> attributes as props
                    width="100%"
                    effect="blur"
                    placeholderSrc={detailData?.cover_photo}
                    onError={imageNotFound}
                  />
                </div>
                <div className="overlayblack-card-info1">
                  <div className="set-overlay1 ">
                    <p>{detailData?.location?detailData?.location:""}</p>
                  
                  </div>
                  <div className="bottom-desc1">
                    <p className="mb-0">
                      {detailData?.area ? detailData?.area :""}
                    </p>
                    <div>
                      <p className="mb-2"> {`${detailData?.propertyType ? getTypeName(detailData?.propertyType) :""}, ${
                                detailData?.bhk === "Storage"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_storage"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_storage"
                                        )[0]["value"] || "lbl_storage"
                                      : "lbl_storage"
                                    : "lbl_storage"
                                  : detailData?.bhk === "Single Room"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_single_room"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_single_room"
                                        )[0]["value"] || "lbl_single_room"
                                      : "lbl_single_room"
                                    : "lbl_single_room"
                                  : detailData?.bhk === "Studio"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_studio"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_studio"
                                        )[0]["value"] || "lbl_studio"
                                      : "lbl_studio"
                                    : "lbl_studio"
                                  : `${detailData?.bhk ? detailData?.bhk :""} ${
                                      frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_rooms"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_rooms"
                                            )[0]["value"] || "lbl_rooms"
                                          : "lbl_rooms"
                                        : "lbl_rooms"
                                    }`
                              }, ${detailData?.size ? detailData?.size:""} ㎡`}</p>
                    </div>
                  </div>
                </div>
                {detailData?.photo_gallery?.length > 0 && (
                  <div className="btn-all-photo1">
                    <button onClick={handleOpen}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_all_photos")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_all_photos"
                          )[0]["value"] || "lbl_all_photos"
                          : "lbl_all_photos"
                        : "lbl_all_photos"}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="set-bottom-btn-white1 d-flex">
              <div className="set-pdd-set-all1">
                {detailData?.favourite === 0 ? (
                  <p onClick={(e) => like(e, detailData?._id)} style={{minWidth:"max-content"}} className="favourite-p">
                    <img src="assets/unfav.svg" alt="Favorites" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_favourite")
                        .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_favourite")[0][
                        "value"
                        ] || "lbl_favourite"
                        : "lbl_favourite"
                      : "lbl_favourite"}
                  </p>
                ) : (
                  <p onClick={(e) => unlike(e, detailData?._id)}  style={{minWidth:"max-content"}}  className="favourite-p">
                    <img src="assets/like.svg" alt="Favorites" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_favourite")
                        .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_favourite")[0][
                        "value"
                        ] || "lbl_favourite"
                        : "lbl_favourite"
                      : "lbl_favourite"}
                  </p>
                )}
              </div>
              <div className="set-pdd-set-all1">
                <p onClick={(e) => hidden(e, detailData?._id)}  className="favourite-p">
                  <img src="assets/icons/hideicon.svg" alt="Hide" />
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_hide").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_hide")[0][
                      "value"
                      ] || "lbl_hide"
                      : "lbl_hide"
                    : "lbl_hide"}
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p  className="favourite-p">
                  <Link
                    to={{
                      pathname: "/properties-map",
                      state: { user: detailData },
                    }}
                    style={{
                      color: "black",
                      textDecoration: "none",
                    }}
                  >
                    <img src="assets/map222.svg" alt="Map" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_map").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_map")[0][
                        "value"
                        ] || "lbl_map"
                        : "lbl_map"
                      : "lbl_map"}
                  </Link>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p onClick={(e) => HandlePrint(e)}  className="favourite-p">
                  <a>
                    <img src="assets/print.svg" alt="Print" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_print").length >
                        0
                        ? frontLabelsName.filter((e) => e.key == "lbl_print")[0][
                        "value"
                        ] || "lbl_print"
                        : "lbl_print"
                      : "lbl_print"}
                  </a>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p onClick={handleAddChat}  className="favourite-p">
               
                  <img src="assets/message.svg" alt="Message" />
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_message").length >
                      0
                      ? frontLabelsName.filter((e) => e.key == "lbl_message")[0][
                      "value"
                      ] || "lbl_message"
                      : "lbl_message"
                    : "lbl_message"}
               
                </p>
              </div>

              <div className="set-pdd-set-all1 btn-apply-property1">
                {detailData?.applied === 0 ? (
                  <p onClick={() => loginCheck(detailData)}  className="favourite-p">
                    <a className="d-flex justify-content-center align-items-center">
                      <img src="assets/icons/applyproperty.svg" alt="Message" />
                      <span>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_apply_property"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_apply_property"
                            )[0]["value"] || "lbl_apply_property"
                            : "lbl_apply_property"
                          : "lbl_apply_property"}
                      </span>
                    </a>
                  </p>
                ) : (
                  <p  className="favourite-p">
                    <a className="d-flex justify-content-center align-items-center disable-links">
                      <img src="assets/icons/applyproperty.svg" alt="Message" />
                      <span>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_already_applied"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_already_applied"
                            )[0]["value"] || "lbl_already_applied"
                            : "lbl_already_applied"
                          : "lbl_already_applied"}
                      </span>
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="right-menu-bar-fill2">
              <div className="first-rent-desc">

                <div className="">
                  

                  {/* Rental price */}
                  <div className="rental-price d-flex justify-content-between align-items-center">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_rental_price")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_rental_price")[0][
                          "value"
                          ] || "lbl_rental_price"
                          : "lbl_rental_price"
                        : "lbl_rental_price"}:{" "}
                    </h3>
                    <h3 className="">
                      {detailData?.propertyPrice}{" "}
                      {/* <span> */}
                      Kr.{" "}
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_per_month")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_per_month"
                          )[0]["value"] || "lbl_per_month"
                          : "lbl_per_month"
                        : "lbl_per_month"}
                  
                    </h3>
                  </div>
                </div>

              </div>

              <div className="desc-pri-set4 pt-3 d-flex align-items-center">
              

                {  
                  <div className="col-12 d-flex justify-content-between pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_power"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_power"
                          )[0]["value"] || "lbl_power"
                          : "lbl_power"
                        : "lbl_power"}:
                    </h3>
                    <h3 className="">
                  
                      {detailData?.powerPrice ? detailData?.powerPrice  : "0" }
                     { " " + "-" + " "}
                      { detailData?.powerPrice ? frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_intended_for"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_intended_for"
                          )[0]["value"] || "lbl_intended_for"
                          : "lbl_intended_for"
                        : "lbl_intended_for" : 
                        
                        frontLabelsName
                        ?
                        frontLabelsName.filter(
                          (e) => e.key == "lbl_included"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_included"
                          )[0]["value"] || "lbl_included"
                          : "lbl_included"
                        : "lbl_included"
                        }
                    </h3>
                  </div>
                }

              

                {
                  <div className="col-12 d-flex justify-content-between pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_hiti"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_hiti"
                          )[0]["value"] || "lbl_hiti"
                          : "lbl_hiti"
                        : "lbl_hiti"}:
                    </h3>
                    <h3 className="">
                    
                      {detailData?.hitiPrice  ? detailData?.hitiPrice + " " + "-" + " "  : 0+ " " + "-" + " "}
                
                         {detailData?.hitiPrice  ?
                       frontLabelsName
                       ? frontLabelsName.filter(
                         (e) => e.key == "lbl_intended_for"
                       ).length > 0
                         ? frontLabelsName.filter(
                           (e) => e.key == "lbl_intended_for"
                         )[0]["value"] || "lbl_intended_for"
                         : "lbl_intended_for"
                       : "lbl_intended_for"
                        :
                        frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_included"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_included"
                            )[0]["value"] || "lbl_included"
                            : "lbl_included"
                          : "lbl_included"
                      } 
                    </h3>
                  </div>
                }


                {
                  <div className="col-12 d-flex justify-content-between pb-2">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_house_fund"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_house_fund"
                          )[0]["value"] || "lbl_house_fund"
                          : "lbl_house_fund"
                        : "lbl_house_fund"}:
                    </h3>
                    <h3 className="">
                      {detailData?.dummy_deposit !=="none" ? detailData?.houseFund ? detailData?.houseFund : "0"+ " " + "-" + " " :""}
                      {detailData?.dummy_deposit !=="none" ? detailData?.houseFund  ?
                       ""
                        :
                        frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_included"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_included"
                            )[0]["value"] || "lbl_included"
                            : "lbl_included"
                          : "lbl_included":
                          frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_none"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_none"
                            )[0]["value"] || "lbl_none"
                            : "lbl_none"
                          : "lbl_none"
                      }
                    </h3>
                  </div>
                }

                {
                  <div className="total-price col-12 d-flex justify-content-between pb-2">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_total"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_total"
                          )[0]["value"] || "lbl_total"
                          : "lbl_total"
                        : "lbl_total"}:
                    </h3>
                    <h3 className="">
                      {detailData?.total} Kr.{" "}
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_per_month")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_per_month"
                          )[0]["value"] || "lbl_per_month"
                          : "lbl_per_month"
                        : "lbl_per_month"}
                    </h3>
                  </div>
                }
                {/* end */}

              </div>

              <div className="liability-insurance d-flex justify-content-between align-items-center pb-2">
                <h3 className="">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_liability_insurance")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_liability_insurance")[0][
                      "value"
                      ] || "lbl_liability_insurance"
                      : "lbl_liability_insurance"
                    : "lbl_liability_insurance"}:{" "}
                </h3>
                <h3 className="">
            
                  { "Kr." }
                </h3>
              </div>

              {detailData?.fee_type &&
                        detailData?.fee_type.includes("bankGuaranteeOpt") &&  <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                  {frontLabelsName
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_bank_guarantee"
                    ).length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_bank_guarantee"
                      )[0]["value"] || "lbl_bank_guarantee"
                      : "lbl_bank_guarantee"
                    : "lbl_bank_guarantee"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
              {detailData?.fee_type &&
                        detailData?.fee_type.includes("insuranceFeeOpt") &&   <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_insurance_fee_amount"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_insurance_fee_amount"
                          )[0]["value"] || "lbl_insurance_fee_amount"
                          : "lbl_insurance_fee_amount"
                        : "lbl_insurance_fee_amount"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
              {detailData?.fee_type &&
                        detailData?.fee_type.includes("rentersInsuranceOpt") &&   <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_insurance1"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_renters_insurance1"
                          )[0]["value"] || "lbl_renters_insurance1"
                          : "lbl_renters_insurance1"
                        : "lbl_renters_insurance1"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
              {detailData?.fee_type &&
                        detailData?.fee_type.includes("securityDepositOpt") && <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_security_deposit"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_security_deposit"
                          )[0]["value"] || "lbl_security_deposit"
                          : "lbl_security_deposit"
                        : "lbl_security_deposit"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
           {detailData?.fee_type &&
                        detailData?.fee_type.includes("otherOpt") &&   <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_other")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0][
                          "value"
                          ] || "lbl_other"
                          : "lbl_other"
                        : "lbl_other"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
             


              <div className="bankguarantee pt-4" style={{ textAlign: "right" }}>
                <button
                  // className="rent-protection"
                  className="btn-app-pro2"
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rent_protection")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_rent_protection"
                      )[0]["value"] || "lbl_rent_protection"
                      : "lbl_rent_protection"
                    : "lbl_rent_protection"}
                </button>
              </div>

              
            
                  <div className=" pt-3  pb-0">
                  <div className="dsc-bottom-all1 ">
                  <h2>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_availability")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_availability"
                        )[0]["value"] || "lbl_availability"
                        : "lbl_availability"
                      : "lbl_availability"}{" "}
                    :
                  </h2>
                  {detailData?.availability === "true" ? (
                    <div className=" pb-2 desc-pri-set4">
                      <div className="d-flex justify-content-between">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_from")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_from"
                              )[0]["value"] || "lbl_from"
                              : "lbl_from"
                            : "lbl_from"}{" "}:
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.availability === "true"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_available_right_away"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_available_right_away"
                                )[0]["value"] || "lbl_available_right_away"
                                : "lbl_available_right_away"
                              : "lbl_available_right_away"
                            : ""}
                        </h2>
                      </div>
                    </div>
                  ) : null}
                  {detailData?.availabilityDate ? (
                    <div className="pb-2 desc-pri-set4">
                      <div className="d-flex justify-content-between">
                        <h2 className="bt-bold ">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_from_date")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_from_date"
                              )[0]["value"] || "lbl_from_date"
                              : "lbl_from_date"
                            : "lbl_from_date"}{" "}:
                        </h2>
                        <h2 className="bt-normal">
                          {moment(detailData?.availabilityDate).format(
                            "DD/MM/yyyy"
                          )}
                        </h2>
                      </div>
                    </div>
                  ) : null}
                  {detailData?.deliveryRightAway === true ? (
                    <div className=" pb-2 desc-pri-set4">
                      <div className="d-flex justify-content-between">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_to")
                              .length > 0
                              ? frontLabelsName.filter((e) => e.key == "lbl_to")[0][
                              "value"
                              ] || "lbl_to"
                              : "lbl_to"
                            : "lbl_to"}{" "}:
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.deliveryRightAway === true
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_long_term"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_long_term"
                                )[0]["value"] || "lbl_long_term"
                                : "lbl_long_term"
                              : "lbl_long_term"
                            : ""}
                        </h2>
                      </div>
                    </div>
                  ) : null}
                  {detailData?.deliveryDate ? (
                    <div className="desc-pri-set4 pb-2">
                      <div className="d-flex justify-content-between">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_to_date")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_to_date"
                              )[0]["value"] || "lbl_to_date"
                              : "lbl_to_date"
                            : "lbl_to_date"}{" "}:
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.deliveryDate
                            ? moment(detailData?.deliveryDate).format(
                              "DD/MM/yyyy"
                            )
                            : "-"}
                        </h2>
                      </div>
                    </div>
                  ) : null}
                </div>
                  
                  </div>
                 



            </div>
          </div>

         
        </div>

     
        <div className="row row_style mt-4">
          <div className="col-lg-12 col-md-12">
           

        <div
              className="row pt-3 mb-0"
              style={{ backgroundColor: "#ffffff", margin: "1px" }}
            > 
              <div className="col-lg-4 col-md-4">
                <div className="right-menu-bar-fill2 spc-f2">
                  <div className="first-rent-desc">
                    <div className="desc-pri-set4">
                      <p className="set-gg">
                        {" "}
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_facilities_accessories"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_facilities_accessories"
                            )[0]["value"] || "lbl_facilities_accessories"
                            : "lbl_facilities_accessories"
                          : "lbl_facilities_accessories"}{" "}
                        :
                      </p>

                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {" "}
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_restroom")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_restroom"
                              )[0]["value"] || "lbl_restroom"
                              : "lbl_restroom"
                            : "lbl_restroom"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.restroom === 0
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_none")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_none"
                                )[0]["value"] || "lbl_none"
                                : "lbl_none"
                              : "lbl_none"
                            : ""}
                          {detailData?.restroom === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_shower")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_shower"
                                )[0]["value"] || "lbl_shower"
                                : "lbl_shower"
                              : "lbl_shower"
                            : ""}
                          {detailData?.restroom === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_bath")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_bath"
                                )[0]["value"] || "lbl_bath"
                                : "lbl_bath"
                              : "lbl_bath"
                            : ""}
                          {detailData?.restroom === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_shower_bath"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_shower_bath"
                                )[0]["value"] || "lbl_shower_bath"
                                : "lbl_shower_bath"
                              : "lbl_shower_bath"
                            : ""}
                          {detailData?.restroom === 4 ? "WC" : ""}
                          {detailData?.restroom === 5
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_joint_restroom"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_joint_restroom"
                                )[0]["value"] || "lbl_joint_restroom"
                                : "lbl_joint_restroom"
                              : "lbl_joint_restroom"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {" "}
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_laundry")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_laundry"
                              )[0]["value"] || "lbl_laundry"
                              : "lbl_laundry"
                            : "lbl_laundry"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.laundry === 0
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_laundry"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_laundry"
                                )[0]["value"] || "lbl_no_laundry"
                                : "lbl_no_laundry"
                              : "lbl_no_laundry"
                            : ""}
                          {detailData?.laundry === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_within_appartment"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_within_appartment"
                                )[0]["value"] || "lbl_within_appartment"
                                : "lbl_within_appartment"
                              : "lbl_within_appartment"
                            : ""}
                          {detailData?.laundry === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_on_floor"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_on_floor"
                                )[0]["value"] || "lbl_on_floor"
                                : "lbl_on_floor"
                              : "lbl_on_floor"
                            : ""}
                          {detailData?.laundry === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_in_basement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_in_basement"
                                )[0]["value"] || "lbl_in_basement"
                                : "lbl_in_basement"
                              : "lbl_in_basement"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {" "}
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_with_furniture"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_with_furniture"
                              )[0]["value"] || "lbl_with_furniture"
                              : "lbl_with_furniture"
                            : "lbl_with_furniture"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.with_furniture === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"
                            : ""}
                          {detailData?.with_furniture === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"
                            : ""}
                          {detailData?.with_furniture === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_aggrement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_aggrement"
                                )[0]["value"] || "lbl_aggrement"
                                : "lbl_aggrement"
                              : "lbl_aggrement"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {" "}
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_garage")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_garage"
                              )[0]["value"] || "lbl_garage"
                              : "lbl_garage"
                            : "lbl_garage"}{" "}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.garage === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"
                            : ""}
                          {detailData?.garage === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"
                            : ""}
                          {detailData?.garage === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_aggrement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_aggrement"
                                )[0]["value"] || "lbl_aggrement"
                                : "lbl_aggrement"
                              : "lbl_aggrement"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_storage")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_storage"
                              )[0]["value"] || "lbl_storage"
                              : "lbl_storage"
                            : "lbl_storage"}{" "}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.storage === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"
                            : ""}
                          {detailData?.storage === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"
                            : ""}
                          {detailData?.storage === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_aggrement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_aggrement"
                                )[0]["value"] || "lbl_aggrement"
                                : "lbl_aggrement"
                              : "lbl_aggrement"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {" "}
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_parking")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_parking"
                              )[0]["value"] || "lbl_parking"
                              : "lbl_parking"
                            : "lbl_parking"}{" "}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.parking === "NoParking"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_parking"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_parking"
                                )[0]["value"] || "lbl_no_parking"
                                : "lbl_no_parking"
                              : "lbl_no_parking"
                            : ""}
                          {detailData?.parking === "OutdoorParking"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_outdoor_parking"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_outdoor_parking"
                                )[0]["value"] || "lbl_outdoor_parking"
                                : "lbl_outdoor_parking"
                              : "lbl_outdoor_parking"
                            : ""}
                          {detailData?.parking === "ParkingGarage"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_parking_garage"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_parking_garage"
                                )[0]["value"] || "lbl_parking_garage"
                                : "lbl_parking_garage"
                              : "lbl_parking_garage"
                            : ""}
                          {detailData?.parking === "PrivateParking"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_private_parking"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_private_parking"
                                )[0]["value"] || "lbl_private_parking"
                                : "lbl_private_parking"
                              : "lbl_private_parking"
                            : ""}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
         <div className="col-lg-4 col-md-4">
                <div className="right-menu-bar-fill2 spc-f2">
                  <div className="first-rent-desc">
                    <div className="desc-pri-set4">
                      <p className="set-gg">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_restrictions"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_restrictions"
                            )[0]["value"] || "lbl_restrictions"
                            : "lbl_restrictions"
                          : "lbl_restrictions"}{" "}
                        :
                      </p>

                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) =>
                                e.key == "lbl_allowed_number_of_inhabitants"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) =>
                                  e.key == "lbl_allowed_number_of_inhabitants"
                              )[0]["value"] ||
                              "lbl_allowed_number_of_inhabitants"
                              : "lbl_allowed_number_of_inhabitants"
                            : "lbl_allowed_number_of_inhabitants"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.inhabitants === "agreement"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_agreement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                )[0]["value"] || "lbl_agreement"
                                : "lbl_agreement"
                              : "lbl_agreement"
                            : detailData?.inhabitants}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_gender")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_gender"
                              )[0]["value"] || "lbl_gender"
                              : "lbl_gender"
                            : "lbl_gender"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.gender === "1"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_only_male"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_only_male"
                                )[0]["value"] || "lbl_only_male"
                                : "lbl_only_male"
                              : "lbl_only_male"
                            : ""}
                          {detailData?.gender === "2"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_only_female"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_only_female"
                                )[0]["value"] || "lbl_only_female"
                                : "lbl_only_female"
                              : "lbl_only_female"
                            : ""}
                          {detailData?.gender === "3"
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_other")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_other"
                                )[0]["value"] || "lbl_other"
                                : "lbl_other"
                              : "lbl_other"
                            : ""}
                          {detailData?.gender === "0"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_all_gender"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_all_gender"
                                )[0]["value"] || "lbl_all_gender"
                                : "lbl_all_gender"
                              : "lbl_all_gender"
                            : ""}
                          {detailData?.gender === "4"
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_couples")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_couples"
                                )[0]["value"] || "lbl_couples"
                                : "lbl_couples"
                              : "lbl_couples"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_smoking")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_smoking"
                              )[0]["value"] || "lbl_smoking"
                              : "lbl_smoking"
                            : "lbl_smoking"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.smoking === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"
                            : ""}
                          {detailData?.smoking === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"
                            : ""}
                          {detailData?.smoking === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_aggrement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_aggrement"
                                )[0]["value"] || "lbl_aggrement"
                                : "lbl_aggrement"
                              : "lbl_aggrement"
                            : ""}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_pets")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_pets"
                              )[0]["value"] || "lbl_pets"
                              : "lbl_pets"
                            : "lbl_pets"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.pets === 1
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"
                            : ""}
                          {detailData?.pets === 2
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"
                            : ""}
                          {detailData?.pets === 3
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_aggrement"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_aggrement"
                                )[0]["value"] || "lbl_aggrement"
                                : "lbl_aggrement"
                              : "lbl_aggrement"
                            : ""}
                        </h2>
                      </div>
                      {detailData?.other_restriction && (
                        <div className="d-flex justify-content-between pb-2">
                          <h2 className="bt-bold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_other_restrictions"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_other_restrictions"
                                )[0]["value"] || "lbl_other_restrictions"
                                : "lbl_other_restrictions"
                              : "lbl_other_restrictions"}
                          </h2>
                          <h2 className="bt-normal" style={{wordBreak:"break-word"}}>
                            {detailData?.other_restriction}
                          </h2>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div> 
            {/* <div className="col-lg-3 col-md-6">
                <div className="right-menu-bar-fill2 spc-f2">
                  <div className="first-rent-desc">
                    <div className="desc-pri-set4">
                      <p className="set-gg">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_availability"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_availability"
                              )[0]["value"] || "lbl_availability"
                            : "lbl_availability"
                          : "lbl_availability"}
                      </p> */}
            {/* <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-normal">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_availability"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_availability"
                                )[0]["value"] || "lbl_availability"
                              : "lbl_availability"
                            : "lbl_availability"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.availability === true
                            ? frontLabelsName
                            ? frontLabelsName.filter(
                                (e) =>
                                  e.key == "lbl_available_right_away"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) =>
                                    e.key == "lbl_available_right_away"
                                )[0]["value"] ||
                                "lbl_available_right_away"
                              : "lbl_available_right_away"
                            : "lbl_available_right_away"
                            : ""}
                        </h2>
                      </div> */}
            {/* </div>
                  </div>
                </div> */}
            {/* <div className="right-menu-bar-fill2 spc-f2">
                  <div className="first-rent-desc">
                    <div className="desc-pri-set4">
                      <p className="set-gg">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_delivery")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_delivery"
                              )[0]["value"] || "lbl_delivery"
                            : "lbl_delivery"
                          : "lbl_delivery"}
                      </p>
                  
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-normal">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_delivery_date"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_delivery_date"
                                )[0]["value"] || "lbl_delivery_date"
                              : "lbl_delivery_date"
                            : "lbl_delivery_date"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.deliveryDate
                            ? moment(detailData?.deliveryDate).format(
                                "DD/MM/yyyy"
                              )
                            : "-"}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div> */}
            {/* </div> */}
         <div className="col-lg-4 col-md-4">
                <div className="right-menu-bar-fill2">
                  <div className="first-rent-desc">
                    <div className="desc-pri-set4">
                      <p className="set-gg">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_landlord")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_landlord"
                            )[0]["value"] || "lbl_landlord"
                            : "lbl_landlord"
                          : "lbl_landlord"}{" "}
                        :
                      </p>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_name")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_name"
                              )[0]["value"] || "lbl_name"
                              : "lbl_name"
                            : "lbl_name"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.landLord_name
                            ? detailData?.landLord_name
                            : detailData?.posted_by?.full_name}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_phone")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_phone"
                              )[0]["value"] || "lbl_phone"
                              : "lbl_phone"
                            : "lbl_phone"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.landLord_mobile_number
                            ? detailData?.landLord_mobile_number
                            : detailData?.posted_by?.mobile_number}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_email")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_email"
                              )[0]["value"] || "lbl_email"
                              : "lbl_email"
                            : "lbl_email"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.landLord_email
                            ? detailData?.landLord_email
                            : detailData?.posted_by?.email}
                        </h2>
                      </div>
                      {/* {detailData?.landLord_RelationToOwner && (
                        <div className="d-flex justify-content-between pb-2">
                          <h2 className="bt-bold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_relation_to_owner"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_relation_to_owner"
                                )[0]["value"] || "lbl_relation_to_owner"
                                : "lbl_relation_to_owner"
                              : "lbl_relation_to_owner"}
                          </h2>
                          <h2 className="bt-normal">
                            {detailData?.landLord_RelationToOwner}
                          </h2>
                        </div>
                      )}
                      {detailData?.landLord_ss_number && (
                        <div className="d-flex justify-content-between pb-2">
                          <h2 className="bt-bold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_social_security_number"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_social_security_number"
                                )[0]["value"] || "lbl_social_security_number"
                                : "lbl_social_security_number"
                              : "lbl_social_security_number"}
                          </h2>
                          <h2 className="bt-normal">
                            {detailData?.landLord_ss_number}
                          </h2>
                        </div>
                      )} */}
                      {/* <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_contact")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_contact"
                              )[0]["value"] || "lbl_contact"
                              : "lbl_contact"
                            : "lbl_contact"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.posted_by?.contact}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_availability"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_availability"
                              )[0]["value"] || "lbl_availability"
                              : "lbl_availability"
                            : "lbl_availability"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.landLord_availability_flag
                            ? getFlagMultilanguage(
                              detailData?.landLord_availability_flag
                            )
                            : getFlagMultilanguage(
                              detailData?.posted_by?.availability
                            )}
                        </h2>
                      </div> */}
                      <div className="d-flex justify-content-between pb-2">
                        <h2 className="bt-bold">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_time")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_time"
                              )[0]["value"] || "lbl_time"
                              : "lbl_time"
                            : "lbl_time"}
                        </h2>
                        <h2 className="bt-normal">
                          {detailData?.landLord_availability
                            ? getAvailabilityMultilanguage(
                              detailData?.landLord_availability
                            )
                            : getAvailabilityMultilanguage(
                              detailData?.posted_by?.availableTime
                            )}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
         </div> 
         <div className="row row_style">
          <div className="col-lg-8 col-md-12">
            <div className="fill-list-main1">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_access")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_access")[0][
                          "value"
                          ] || "lbl_access"
                          : "lbl_access"
                        : "lbl_access"}
                    </h2>
                    {detailData?.access && detailData?.access.length > 0
                      ? includs(accessType, detailData?.access)
                      : null}

                    {detailData?.access && detailData?.access.length > 0
                      ? includs1(accessType, detailData?.access)
                      : null}
                    {detailData?.access &&
                      detailData?.access.length === 0 &&
                      includs2(accessType)}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_other")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0][
                          "value"
                          ] || "lbl_other"
                          : "lbl_other"
                        : "lbl_other"}
                    </h2>
                    {detailData?.other_facilities &&
                      detailData?.other_facilities.length > 0
                      ? includs(otherType, detailData?.other_facilities)
                      : null}

                    {detailData?.other_facilities &&
                      detailData?.other_facilities.length > 0
                      ? includs1(otherType, detailData?.other_facilities)
                      : null}
                    {detailData?.other_facilities &&
                      detailData?.other_facilities.length === 0 &&
                      includs2(otherType)}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_home_appliances"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_home_appliances"
                          )[0]["value"] || "lbl_home_appliances"
                          : "lbl_home_appliances"
                        : "lbl_home_appliances"}
                    </h2>

                    {detailData?.homeAppliances &&
                      detailData?.homeAppliances.length > 0
                      ? includs(homeApplianceType, detailData?.homeAppliances)
                      : null}

                    {detailData?.homeAppliances &&
                      detailData?.homeAppliances.length > 0
                      ? includs1(homeApplianceType, detailData?.homeAppliances)
                      : null}
                    {detailData?.included &&
                      detailData?.homeAppliances.length === 0 &&
                      includs2(homeApplianceType)}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_restrictions"
                          )[0]["value"] || "lbl_restrictions"
                          : "lbl_restrictions"
                        : "lbl_restrictions"}
                    </h2>

                    {detailData?.restrictions &&
                      detailData?.restrictions.length > 0
                      ? includs(restrictionsType, detailData?.restrictions)
                      : null}

                    {detailData?.restrictions &&
                      detailData?.restrictions.length > 0
                      ? includs1(restrictionsType, detailData?.restrictions)
                      : null}
                    {detailData?.included &&
                      detailData?.restrictions.length === 0 &&
                      includs2(restrictionsType)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 google-map-col">
            <div className="google-map-code">
        
              {!mapLoading && (
                <MapComponentDetail
                  detailData={detailData}
                  propertyLoading={propertyLoading}
                // hidden={hidden}
                // unlike={unlike}
                // like={like}
                />
              )}

              {mapLoading && <Loading />}
            </div>
          </div>
        </div>
        <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="dsc-bottom-all1 ">
                  <h2>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_description")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_description"
                        )[0]["value"] || "lbl_description"
                        : "lbl_description"
                      : "lbl_description"}{" "}
                    :
                  </h2>
                  <p className="">{detailData?.description}</p>
                </div>
              </div>
       
            </div>
            <div className="btn-tow-bottom-side d-flex justify-content-between mt-2 pb-2 reported-styles">
              {detailData?.reported === 0 ? (
              
                <button
                  className="btn-reportspam1"
                  onClick={(e) => reportdetails(e, detailData?._id)}
                >
                  <span>
                    <img src="assets/report.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_report_here")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_report_here"
                        )[0]["value"] || "lbl_report_here"
                        : "lbl_report_here"
                      : "lbl_report_here"}
                  </span>
                </button>
              ) : (
                // </Link>
                <button className="btn-reportspam1 disable-links-button">
                  <span>
                    <img src="assets/report.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_already_reported"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_already_reported"
                        )[0]["value"] || "lbl_already_reported"
                        : "lbl_already_reported"
                      : "lbl_already_reported"}
                  </span>
                </button>
              )}

              {detailData?.applied === 0 ? (
                <button
                  className="btn-app-pro1"
                  // onClick={applyToggle}
                  onClick={() => loginCheck(detailData)}
                  disabled={detailData?.applied === 1}
                >
                  <span>
                    <img src="assets/applyforaproperty.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_apply_property")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_apply_property"
                        )[0]["value"] || "lbl_apply_property"
                        : "lbl_apply_property"
                      : "lbl_apply_property"}
                  </span>
                </button>
              ) : (
                <button
                  className="btn-app-pro1 disable-links"
                  onClick={applyToggle}
                  disabled={detailData?.applied === 1}
                >
                  <span>
                    <img src="assets/applied.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_already_applied")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_already_applied"
                        )[0]["value"] || "lbl_already_applied"
                        : "lbl_already_applied"
                      : "lbl_already_applied"}
                  </span>
                </button>
              )}
            </div>
    <div className="similar-proprty d-flex justify-content-between">
              <h2>
                <span>
                  <img src="assets/similarproperties.svg" />
                  {frontLabelsName
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_similar_properties"
                    ).length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_similar_properties"
                      )[0]["value"] || "lbl_similar_properties"
                      : "lbl_similar_properties"
                    : "lbl_similar_properties"}
                </span>
              </h2>
              <h2>
                <Link to="/properties-list">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_see_more").length >
                      0
                      ? frontLabelsName.filter((e) => e.key == "lbl_see_more")[0][
                      "value"
                      ] || "lbl_see_more"
                      : "lbl_see_more"
                    : "lbl_see_more"}
                </Link>
              </h2>
            </div>
          <div className="bottom-slider">
              <Slider {...settings}>
                {!propertyLoading && property.docs.length > 0 ? (
                  property.docs.map((list, i) => (
                    <div className="view-card-main2 mt-2" key={i}>
                      <Link to={`/property-details/${list._id}`}>
                        <div className="img-view-main2 ">
                          <img
                            src={
                              list.cover_photo
                                ? list.cover_photo
                                : list.photo_gallery[0]
                            }
                            alt="img1"
                            width="100%"
                            height="300px "
                          />
                        </div>
                        <div className="overlayblack-card1">
                          <div className="set-overlay2">
                            <p style={{lineHeight:1}}>
                              {list.location.length > 30
                                ? list.location.substring(0, 30) + "..."
                                : list.location}
                            </p>
                            <div className="bottom-desc2 d-flex">
                              <p style={{lineHeight:1.2}}>
                                {list.description.length > 80
                                  ? list.description.substring(0, 80) + "..."
                                  : list.description}
                              </p>
                              <span>
                                {list.property_price ||
                                  list.sale_price ||
                                  list.pg_price}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <Loading />
                )}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      {/* apply modal */}
      {/* <Modal
        open={false}
        onClose={handleApplyModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="property-model1"
        disableScrollLock={true}
        keepMounted={true}
      >
        <Box className="modal-content model-box1">
          <Form className="p-4">
            <div className="model-header-custom">
              <div className="desc-md-custom">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_are_you_sure_you_want_to_apply_for"
                    ).length > 0
                      ? frontLabelsName.filter(
                        (e) =>
                          e.key == "lbl_are_you_sure_you_want_to_apply_for"
                      )[0]["value"] ||
                      "lbl_are_you_sure_you_want_to_apply_for"
                      : "lbl_are_you_sure_you_want_to_apply_for"
                    : "lbl_are_you_sure_you_want_to_apply_for"}{" "}
                  {applyBoxData.location}, {applyBoxData.area} ?
                </h2>
                <div className="d-flex custom-fll2">
                  <button onClick={applyModelProperty}>
                    {" "}
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_yes").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_yes")[0][
                        "value"
                        ] || "lbl_yes"
                        : "lbl_yes"
                      : "lbl_yes"}
                  </button>
                  <button onClick={handleApplyModal}>
                    {" "}
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_no").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_no")[0][
                        "value"
                        ] || "lbl_no"
                        : "lbl_no"
                      : "lbl_no"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Box>
      </Modal> */}

      {/* new apply property model */}

      <Dialog
        open={openApplyBox}
        onClose={handleApplyModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        alignItems="center"
        className="property-model22"
        sx={{
          p: 3,
          "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            borderRadius: "15px",
            width: { lg: "580px", md: "400px", sm: "370px", xs: "350px" },
          },
        }}
      >
        {openApplyBox && (
          <>
            <DialogTitle
              id="alert-dialog-title"
              sx={{ fontSize: { xs: 18, sm: 20, md: 22, lg: 26 } }}
            >
              {frontLabelsName
                ? frontLabelsName.filter(
                  (e) => e.key == "lbl_are_you_sure_you_want_to_apply_for"
                ).length > 0
                  ? frontLabelsName.filter(
                    (e) => e.key == "lbl_are_you_sure_you_want_to_apply_for"
                  )[0]["value"] || "lbl_are_you_sure_you_want_to_apply_for"
                  : "lbl_are_you_sure_you_want_to_apply_for"
                : "lbl_are_you_sure_you_want_to_apply_for"}{" "}
              <br />
              {applyBoxData.location}, {applyBoxData.area} ?
            </DialogTitle>
            <DialogContent>
              <div className="custom-file-input4">
            <Button
              variant="contained"
           
              component="label"
              className="upload-button-style margin-bottom-style "
            >
              <FaFileUpload
                style={{
                  marginRight: 10,
                  color: "#8B9194",
                }}
              />
              {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_upload_renter_cv")
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_upload_renter_cv"
                    )[0]["value"] || "lbl_upload_renter_cv"
                  : "lbl_upload_renter_cv"
                : "lbl_upload_renter_cv"}     <span className="required-astreik">*</span>

              <input
                onChange={handleFileChange}
                hidden
                accept="pdf/*"
                multiple
                type="file"
                className="custom-file-input1"
                id="handleupload"
              />
            </Button>
             {frontLabelsName
                ? frontLabelsName.filter(
                  (e) => e.key == "lbl_only_pdf_allowed_you_can_download_your_renter_cv_from_rental_profile_form"
                ).length > 0
                  ? frontLabelsName.filter(
                    (e) => e.key == "lbl_only_pdf_allowed_you_can_download_your_renter_cv_from_rental_profile_form"
                  )[0]["value"] || "lbl_only_pdf_allowed_you_can_download_your_renter_cv_from_rental_profile_form"
                  : "lbl_only_pdf_allowed_you_can_download_your_renter_cv_from_rental_profile_form"
                : "lbl_only_pdf_allowed_you_can_download_your_renter_cv_from_rental_profile_form"}
                 {pdfError && (
                                  <span className="invalid_span">
                                    {pdfError}
                                  </span>
                                )}
                                {pdfurl?.name &&  
                                <div className="d-flex align-items-center">
                                     <img src="assets/pin.png" alt="pin" height={20} width={20}/> 
                                  <p className="ps-1 mb-0 fw-semibold">{pdfurl?.name}</p>
                                </div>
                                 }
          </div>
            </DialogContent>
            <DialogActions
              sx={{ p: 2.5, justifyContent: "center", gap: "10px" }}
              className="active-buttons"
            >
              <button
                className="apply-model-box"
                onClick={applyModelProperty}
                disabled={disableSubmitButton}
             style={{alignItems:"center",display:"flex",justifyContent:"center"}}
       
              >
          {disableSubmitButton ? ( 
                        <CircularProgress
                          size={24}
                          sx={{
                            ":hover": { color: "#000" },

                            color: "#000",
                           
                          }}
                        />
                  ) :
                frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_yes").length > 0
                   ? frontLabelsName.filter((e) => e.key == "lbl_yes")[0][
                "value"
                    ] || "lbl_yes"
                   : "lbl_yes"
                 : "lbl_yes"} 
              </button>

              <button
                onClick={handleApplyModal}
                disabled={disableSubmitButton}
             
                className="apply-model-box"
      
              >
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_no").length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_no")[0]["value"] ||
                    "lbl_no"
                    : "lbl_no"
                  : "lbl_no"}
              </button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* image slider model */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overlay: { background: "black" } }}
      >
        <Box className="model-box">
          <img
            src="assets/cross.svg"
            onClick={handleClose}
            className="cross-img"
          />

          <ImageGallery
            items={imgSlider_Model}
            showFullscreenButton={false}
            showPlayButton={false}
            autoPlay={true}
            onErrorImageURL="assets/no-picture-available-icon-1.jpg"
          />
        </Box>
      </Modal>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  properties: state.properties,
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  getPropertyDetail,
  getPropertyList,
  applyProperty,
  loadUser,
  likeProperty,
  unlikeProperty,
  hiddenProperty,
  reportProperty,
  addChat,
  PrintPropertyDetail,
  dropdownPropertyField,
})(PropertyInfo4);
